import { useIonToast } from '@ionic/react';
import { keyOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';

import ActionButton from '../../../../components/button/ActionButton';
import InputItem from '../../../../components/input/InputItem';
import { DataProvider } from '../../../../library/DataProvider';
import { ChangePasswordPostAction } from '../../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

import './ChangePassword.css';
import 'react-responsive-modal/styles.css';

interface Props {
    show: boolean,
    hide: any
}

const ChangePassword: React.FC<Props> = (props) => {
    const [form, setForm] = useState({
        current_password: { value: "", validation: { required: true }, error: "" },
        new_password: { value: "", validation: { required: true }, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()
    const { form_loading, resp } = useAppSelector(state => state.changePasswordPost)

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            dispatch(ChangePasswordPostAction(form.current_password.value, form.new_password.value))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    props.hide();

                    toast({ message: resp.message, duration: 2000, color: "primary" })

                    formProvider.reset();
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    return <Modal open={props.show} onClose={props.hide} center showCloseIcon={false} container={window.modalContainer.current}>
        <form onSubmit={formSubmitHandler}>
            <InputItem name="current_password" type="password" label="رمز عبور فعلی" icon={keyOutline} ltr maxlength={20} provider={formProvider} />

            <InputItem name="new_password" type="password" label="رمز عبور جدید" icon={keyOutline} ltr maxlength={20} provider={formProvider} />

            <ActionButton text="تغییر رمز عبور" loading={form_loading} />
        </form>
    </Modal>
}

export default ChangePassword